import initState from '@shared/init-state-v0.1.0'
import type { BaseJsProps } from '@shared/node-v1.0.0'
import type { JsNodeDef } from '@shared/node-v1.0.0'
import { getPortDef } from '@shared/port-v1.0.0'
import { unSubscribeAll } from '../component/handleSubscribe'
import getStore from './store'
import type { LiveQuery, Store } from './store'

export type Props = BaseJsProps & BaseProps & { store: Store }

export type BaseProps = {
	query?: string
	liveQueries?: LiveQuery[]
}

export default {
	hashTag: '#pre-release',
	module: { dynamic: import('../component') },
	inNode: {
		inputs: [
			getPortDef({
				name: 'query',
				displayName: 'Query',
				group: 'Params',
				type: 'string',
				multiline: true,
			}),
			getPortDef({
				name: 'liveQueries',
				displayName: 'Live queries',
				group: 'Params',
				type: 'array',
				validate: (p: Props) =>
					p.liveQueries ? (p.liveQueries?.every((q) => typeof q === 'function') ? true : 'Live queries must be functions') : true,
			}),
			getPortDef({ name: 'refetch', displayName: 'Refetch', group: 'Signals', type: 'signal' }),
		],
		outputs: [
			getPortDef({ name: 'fetching', displayName: 'Fetching', group: 'States', type: 'boolean' }),
			getPortDef({ name: 'fetched', displayName: 'Fetched', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'response', displayName: 'Response', group: 'Data', type: 'array' }),
		],
	},
	afterNode: {
		triggerOnInputs: () => ['query', 'liveTables', 'liveQueries'],
		getInspectInfo: (p, _, noodlNode) => [{ type: 'text', value: `fetching: ${noodlNode._internal.fetching}` }],
	},
	beforeComponent: {
		initialize: async (p: Props, noodlNode) => {
			await initState('auth')
			p.store = getStore()

			// Отпишемся, когда родитель отмонтировался. Родитель может быть страницей, в таком случае пропустим.
			if (noodlNode.nodeScope.componentOwner.parent?.innerReactComponentRef)
				noodlNode.nodeScope.componentOwner.parent.innerReactComponentRef.componentWillUnmount = () => unSubscribeAll(p)
			// Отпишемся, когда удален.
			noodlNode._onNodeDeleted = () => unSubscribeAll(p)
		},
	},
	disableCustomProps: true,
} satisfies JsNodeDef
